import { AutoComplete, Button } from 'antd';
import { DataSourceItemObject } from "antd/lib/auto-complete";
import * as React from "react";

interface ISearchProps {
    data: any[],
    onChange: (value: string) => void,
    placeholder: string,
    columnName: string,
}

interface ISearchState {
    data: DataSourceItemObject[],
    dataSource: DataSourceItemObject[],
    value: string,
}

class ColumnSearch extends React.Component<ISearchProps, ISearchState> {
    public constructor(props: ISearchProps) {
        super(props);
        const initDataSource = this.getDataSources(props.data);
        this.state = {
            data: initDataSource,
            dataSource: initDataSource,
            value: '',
        };
    }

    public componentWillReceiveProps(nextProps: any) {
        if (nextProps.data !== this.props.data) {
            const updatedDataSource = this.getDataSources(nextProps.data);
            this.setState({
                data: updatedDataSource,
                dataSource: updatedDataSource,
            });
        }
    }

    public getDataSources(data: any[]): DataSourceItemObject[] {
        return data.map((record: any) => {
            return ({
                text: `${record[this.props.columnName]}`,
                value: `${record[this.props.columnName]}`,
            }) as DataSourceItemObject;
        }) as DataSourceItemObject[];
    };

    public handleSearch = (value: string) => {
        value = value.toLowerCase();
        const { data } = this.state;
        this.setState({ value });
        if (!value) {
            this.setState({
                dataSource: data,
            });
            return;
        }
        this.setState({
            dataSource: data.filter((obj: DataSourceItemObject) => obj.text.toLowerCase().includes(value)),
        });
    };

    public onSelect = (value: any) => {
        this.setState({ value });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    public onClear = () => {
        this.setState({ value: '' });
        if (this.props.onChange) {
            this.props.onChange('');
        }
    }

    public removeDuplicates = (dataSource: DataSourceItemObject[], key: keyof DataSourceItemObject) => {
        const values: string[] =  dataSource.map(record => record[key]);
        return dataSource.filter((record, index: number) => {
            return values.indexOf(record[key]) === index;
        });
    }

    public render() {
        const dataSource: DataSourceItemObject[] = this.removeDuplicates(this.state.dataSource, 'value');
        return (
            <div>
                <AutoComplete
                    dataSource={dataSource}
                    style={{ width: 200 }}
                    onSelect={this.onSelect}
                    onSearch={this.handleSearch}
                    placeholder={this.props.placeholder}
                    value={this.state.value}
                />
                <Button style={{ marginLeft: 2 }} type="primary" onClick={this.onClear}>Clear</Button>
            </div>
        );
    }
}

export default ColumnSearch;
